import BaseAPI from '@/services/api/internal/tools/baseAPI';

const EntitiesAPI = new BaseAPI({
  url: `${process.env.USER_PREFERENCES_BASE_URI}/entities`,
});

export default EntitiesAPI;
